import { forwardRef } from "react";
import { Globe, ShieldCheck, Network } from "lucide-react";

const values = [
  {
    icon: Globe,
    title: "Acesso Sem Fronteiras",
    description: "Faça a gestão das suas coleções a partir de qualquer lugar, em qualquer navegador.",
  },
  {
    icon: ShieldCheck,
    title: "Segurança Elevada",
    description: "Controlo rigoroso de acessos (RBAC) e auditoria completa de cada alteração efetuada.",
  },
  {
    icon: Network,
    title: "Arquitetura Multi-Site",
    description: "Ideal para redes de museus ou arquivos que necessitam de gerir múltiplos núcleos de forma independente numa única instalação.",
  },
];

const ValueProposition = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} className="py-24 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Uma plataforma, infinitas possibilidades de gestão.
          </h2>
          <p className="mt-5 text-muted-foreground text-lg leading-relaxed">
            Desenvolvido para superar as limitações dos softwares tradicionais, o Index Rerum
            elimina a necessidade de instalações complexas e infraestruturas pesadas. Acesso total a partir de qualquer navegador, sem necessidade de instalações locais.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border">
          {values.map((v, i) => (
            <div
              key={v.title}
              className={`group relative p-10 bg-background transition-all duration-500 ease-out cursor-default overflow-hidden animate-fade-up animation-delay-${(i + 1) * 100}`}
            >
              {/* Hover background fill effect */}
              <div className="absolute inset-0 bg-foreground scale-y-0 origin-bottom transition-transform duration-500 ease-out group-hover:scale-y-100" />
              
              <div className="relative z-10">
                <div className="w-14 h-14 rounded-full border-2 border-foreground/20 flex items-center justify-center mb-6 transition-all duration-500 group-hover:border-background/30 group-hover:bg-background/10">
                  <v.icon className="w-6 h-6 text-foreground transition-colors duration-500 group-hover:text-background" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3 font-serif transition-colors duration-500 group-hover:text-background">{v.title}</h3>
                <p className="text-muted-foreground leading-relaxed transition-colors duration-500 group-hover:text-background/70">{v.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

ValueProposition.displayName = "ValueProposition";

export default ValueProposition;
